import { newAPI } from 'services';
import qs from 'qs';

export const requestRemoveOs = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/serviceorders/delete-by-period`, qs.stringify(params));
  return response.data;
}

export const requestForceVehicleExit = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/serviceorders/finish_and_open_start`, qs.stringify(params));
  return response.data;
}

export const requestChangeAccount = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/transfer-ownership`, qs.stringify(params));
  return response.data;
}

export const requestImportClients = async (userId, establishmentId, file) => {
  const form = new FormData();

  form.append('file', file);

  const response = await newAPI({
    method: 'post',
    url: `${userId}/establishment/${establishmentId}/clients/import`,
    data: form,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
}